import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { site } from "../data/site";

export const Eyebrow = ({ children, light }) => (
  <span className={`eyebrow ${light ? "eyebrow-light" : ""}`}>{children}</span>
);

export const PageHero = ({ eyebrow, title, subtitle, image, testid }) => (
  <section className="relative bg-[#1A3D84]" data-testid={testid}>
    <div className="absolute inset-0">
      {image && <img src={image} alt="" className="w-full h-full object-cover opacity-30" loading="eager" />}
      <div className="absolute inset-0 bg-gradient-to-r from-[#1A3D84] via-[#1A3D84]/90 to-[#1A3D84]/55" />
    </div>
    <div className="container-custom relative z-10 py-16 md:py-24">
      <div className="max-w-3xl">
        {eyebrow && <div className="mb-5"><Eyebrow light>{eyebrow}</Eyebrow></div>}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl text-white mb-4">{title}</h1>
        {subtitle && <p className="text-base md:text-lg text-white/80 leading-relaxed max-w-2xl">{subtitle}</p>}
      </div>
    </div>
  </section>
);

export const SectionHeading = ({ eyebrow, title, copy, center, className = "" }) => (
  <div className={`${center ? "text-center max-w-2xl mx-auto" : "max-w-2xl"} ${className}`}>
    {eyebrow && <div className={`mb-4 ${center ? "flex justify-center" : ""}`}><Eyebrow>{eyebrow}</Eyebrow></div>}
    <h2 className="text-3xl sm:text-4xl lg:text-5xl mb-4">{title}</h2>
    {copy && <p className="text-base text-neutral-600 leading-relaxed">{copy}</p>}
  </div>
);

export const CTABand = ({
  title = "Ready to Bring Your Project to Life?",
  copy = "Tell us about your project and let Premier Granite help you explore the right stone, design and installation solution.",
}) => (
  <section className="section bg-[#1A3D84] relative overflow-hidden" data-testid="cta-band">
    <div className="container-custom relative z-10 text-center max-w-3xl mx-auto">
      <div className="flex justify-center mb-5"><Eyebrow light>Get a Free Estimate</Eyebrow></div>
      <h2 className="text-3xl sm:text-4xl lg:text-5xl text-white mb-5">{title}</h2>
      <p className="text-white/75 text-base md:text-lg mb-9 leading-relaxed">{copy}</p>
      <div className="flex flex-wrap justify-center gap-4">
        <Link to="/contact" data-testid="ctaband-estimate" className="btn btn-primary">
          Get a Free Estimate <ArrowRight size={18} />
        </Link>
        <a href={site.emailHref} className="btn btn-outline-light">{site.email}</a>
      </div>
      <a href={site.phoneHref} className="inline-flex items-center gap-2 mt-6 text-white/70 hover:text-white text-sm transition-colors">
        <Phone size={15} /> {site.phone}
      </a>
    </div>
  </section>
);
